import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonToolbar,
  ButtonGroup,
  Panel,
  Stack,
  Loader,
  DatePicker,
  Whisper,
  IconButton,
  Tooltip,
  Drawer,
  Form,
  TagPicker,
  Text,
  List,
  HStack,
  Avatar,
  Tag,
  Placeholder,
  Card,
  SelectPicker
} from 'rsuite';
import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getBuildings, getFloors, getFloorsByBuilding } from '@/services/floor.service';
import Floor from './Floor';
import { fetchHorizonSettings, fetchSetting } from '@/services/setting.service';
import { addDays, endOfDay, format, isAfter, isBefore, startOfDay, subDays } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdLocationOff, MdPersonSearch } from 'react-icons/md';
import { Minus, Plus } from '@rsuite/icons';
import { ImAidKit } from 'react-icons/im';
import { FaFireExtinguisher } from 'react-icons/fa';
import { RiMapPinUserFill } from 'react-icons/ri';
import { getBuildingUsers, getUsers } from '@/services/user.service';
import './style.less';

const ContentPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const location = useLocation();
  const reservationData = location.state;

  const floors = useAppSelector((state: any) => state.floor?.data);
  const users = useAppSelector((state: any) => state.users?.data);
  const allFloors = useAppSelector((state: any) => state.floor?.data);
  const loadingusers = useAppSelector((state: any) => state.users?.loading);
  const usersBuilding = useAppSelector((state: any) => state.users?.building);
  const buildings = useAppSelector((state: any) => state.building?.data);
  const loadingBuildings = useAppSelector((state: any) => state.building?.loading);
  const loadingUsersBuilding = useAppSelector((state: any) => state.users?.loadingBuilding);

  const loading = useAppSelector((state: any) => state.floor?.loading);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedFloor, setSelectedFloor] = useState<any>(null);
  const [desks, setDesks] = useState<any>([]);
  const [horizon, setHorizon] = useState();
  const [located, setLocated] = useState<any>({ status: false });
  const [scale, setScale] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [selectedFilters, setSelectedFilters] = useState<any>([]);
  const [selectedBuilding, setSelectedBuilding] = useState(null);

  const maxScale = 3;
  const minScale = 0.5;

  useEffect(() => {
    dispatch(getUsers());
    dispatch(getBuildings());

    const fetchSettingFunc = async () => {
      const res = await fetchHorizonSettings('Desk');
      setHorizon(res);
    };

    fetchSettingFunc();
  }, []);

  useEffect(() => {
    if (buildings?.length > 0) {
      setSelectedBuilding(buildings[0]?._id);
    }
  }, [buildings]);

  useEffect(() => {
    selectedBuilding && dispatch(getFloorsByBuilding(selectedBuilding));
  }, [selectedBuilding]);

  useEffect(() => {
    if (floors?.length > 0 && !selectedFloor) {
      setSelectedFloor(floors[0]);
    }
  }, [floors]);

  useEffect(() => {
    if (selectedBuilding && selectedDate && openDrawer) {
      dispatch(getBuildingUsers(selectedBuilding, format(selectedDate, 'yyyy-MM-dd')));
    }
  }, [selectedBuilding, selectedDate, openDrawer]);

  useEffect(() => {
    if (floors.length > 0 && reservationData) {
      setSelectedFloor(floors.find(item => item._id == reservationData?.floorId));
      setSelectedDate(new Date(reservationData?.date));
    }
  }, [reservationData, floors]);

  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.2, maxScale));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.2, minScale));
  };

  const locateDesk = async (deskId, floorId, slots) => {
    document.querySelectorAll('.animate-desk').forEach(desk => {
      desk.classList.remove('animate-desk');
    });

    if (selectedFloor?._id !== floorId) {
      const newFloor = allFloors.find(item => item._id === floorId);
      setSelectedFloor(newFloor);
      setDesks([]);
      await new Promise(resolve => setTimeout(resolve, 3000));
    }

    const svgElement = document.getElementById('floorPlanSVG');
    const containerElement = document.getElementById('floorPlanContainer');

    if (svgElement && containerElement) {
      const locatedDesks: any = [];

      slots.forEach(slot => {
        const deskElement = document.getElementById(deskId + '-' + slot);
        if (deskElement) {
          deskElement.classList.add('animate-desk');
          locatedDesks.push({ status: true, desk: deskElement, svgPlan: svgElement });
        }
      });

      if (locatedDesks.length > 0) {
        setLocated(locatedDesks);

        let totalCenterX = 0;
        let totalCenterY = 0;
        locatedDesks.forEach(({ desk }) => {
          const deskBox = desk.getBBox();
          totalCenterX += deskBox.x + deskBox.width / 2;
          totalCenterY += deskBox.y + deskBox.height / 2;
        });

        const avgCenterX = totalCenterX / locatedDesks.length;
        const avgCenterY = totalCenterY / locatedDesks.length;

        const zoomFactor = 1.8;
        const scaledDeskX = avgCenterX * zoomFactor;
        const scaledDeskY = avgCenterY * zoomFactor;

        const containerBox = containerElement.getBoundingClientRect();
        const containerCenterX = containerBox.width / 2;
        const containerCenterY = containerBox.height / 2;

        const newX = containerCenterX - scaledDeskX;
        const newY = containerCenterY - scaledDeskY;

        // setPosition({ x: newX, y: newY });
        // setScale(zoomFactor);
      }
    }
  };

  const handleChangeMembers = selectedTags => {
    if (selectedTags.includes('all')) {
      setSelectedUsers(users.map(user => user._id));
    } else if (selectedTags.length === users.length && !selectedTags.includes('all')) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(selectedTags);
    }
  };

  const handleFilterToggle = filter => {
    setSelectedFilters(prevFilters =>
      prevFilters.includes(filter)
        ? prevFilters.filter(f => f !== filter)
        : [...prevFilters, filter]
    );
  };

  const handleReset = () => {
    document.querySelectorAll('.animate-desk').forEach(desk => {
      desk.classList.remove('animate-desk');
    });
    setPosition({ x: 0, y: 0 });
    setScale(1);
    setLocated([]);
  };

  const filteredUsersBuilding = usersBuilding?.filter(item => {
    const userMatches = selectedUsers.length === 0 || selectedUsers.includes(item.user._id);
    const sstMatches =
      selectedFilters.length === 0 || !selectedFilters.includes('isSST') || item.user.isSST;
    const gfsfMatches =
      selectedFilters.length === 0 || !selectedFilters.includes('isGFSF') || item.user.isGFSF;
    return userMatches && sstMatches && gfsfMatches;
  });

  return (
    <Panel bodyFill style={{ background: '#fff', padding: 20 }}>
      <Stack justifyContent="space-between" alignItems="flex-start" spacing={50}>
        <Stack>
          <Form>
            <Form.Group>
              <Form.ControlLabel>{t('Office')}</Form.ControlLabel>
              <SelectPicker
                data={buildings?.map(building => ({
                  ...building,
                  value: building?._id,
                  label: building?.address
                }))}
                searchable={false}
                style={{ width: 200, backgroundColor: 'transparent' }}
                placeholder={t('Select Building')}
                value={selectedBuilding}
                onChange={setSelectedBuilding}
                loading={loadingBuildings}
              />
            </Form.Group>
            {loading ? (
              <Stack justifyContent="center" style={{ marginTop: 50 }}>
                <Loader content={t('Loading floors...')} />
              </Stack>
            ) : (
              <Stack direction="column" spacing={10} justifyContent="flex-start">
                {floors?.map(floor => (
                  <Card
                    key={floor._id}
                    bordered
                    style={{
                      width: 200,
                      height: 50,
                      textAlign: 'center',
                      background: 'none',
                      borderRadius: 10,
                      paddingRight: 15,
                      paddingLeft: 15,
                      backgroundColor:
                        selectedFloor?.floor_num === floor.floor_num
                          ? 'rgb(216, 227, 238)'
                          : 'transparent',
                      marginTop: 10,
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setDesks([]);
                      setSelectedFloor(floor);
                    }}
                  >
                    <Stack justifyContent="space-between" alignItems="center">
                      <h5 style={{ fontSize: 14, margin: '8px 0', fontWeight: 'bold' }}>
                        {floor.name}
                      </h5>
                    </Stack>
                  </Card>
                ))}
              </Stack>
            )}
          </Form>
        </Stack>
        <Stack justifyContent="center" alignItems="center" style={{ flexGrow: 1, width: '100%' }}>
          {selectedFloor ? (
            <Stack direction="column" spacing={2}>
              <DatePicker
                format="dd-MM-yyyy"
                placement="auto"
                value={selectedDate}
                style={{ width: 200 }}
                onChange={setSelectedDate}
                oneTap
                disabledDate={(date: Date) => {
                  const today = new Date();
                  const maxDate = addDays(today, horizon?.NBDays ?? 0);
                  return isBefore(date, startOfDay(today)) || isAfter(date, endOfDay(maxDate));
                }}
              />
              <Floor
                floor={selectedFloor}
                selectedDate={selectedDate}
                desks={desks}
                setDesks={setDesks}
                scale={scale}
                position={position}
                setPosition={setPosition}
              />
            </Stack>
          ) : (
            <Stack justifyContent="center" style={{ marginTop: 50 }}>
              <p>{t('Please select a floor to view its availability.')}</p>
            </Stack>
          )}
        </Stack>
        <Stack direction="row" spacing={10} style={{ marginTop: 10 }}>
          <ButtonToolbar>
            <ButtonGroup vertical>
              {located.length > 0 && (
                <Whisper
                  placement="top"
                  controlId="control-id-click"
                  trigger="hover"
                  speaker={<Tooltip>{t('Cancel Locate')}</Tooltip>}
                >
                  <IconButton
                    appearance="subtle"
                    icon={<MdLocationOff size={20} />}
                    onClick={() => handleReset()}
                  />
                </Whisper>
              )}
              <Whisper
                placement="top"
                controlId="control-id-click"
                trigger="hover"
                speaker={<Tooltip>{t("Who's in the office")}</Tooltip>}
              >
                <IconButton
                  appearance="subtle"
                  icon={<MdPersonSearch size={20} />}
                  onClick={() => setOpenDrawer(true)}
                />
              </Whisper>
              <Whisper
                placement="top"
                controlId="control-id-click"
                trigger="hover"
                speaker={<Tooltip>{t('Zoom in')}</Tooltip>}
              >
                <IconButton appearance="subtle" icon={<Plus />} onClick={handleZoomIn} />
              </Whisper>
              <Whisper
                placement="top"
                controlId="control-id-click"
                trigger="hover"
                speaker={<Tooltip>{t('Zoom out')}</Tooltip>}
              >
                <IconButton appearance="subtle" icon={<Minus />} onClick={handleZoomOut} />
              </Whisper>
            </ButtonGroup>
          </ButtonToolbar>
        </Stack>
      </Stack>

      {openDrawer && (
        <Drawer
          backdrop={false}
          size={400}
          placement={'right'}
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
        >
          <Drawer.Header>
            <Drawer.Title>{t("Who's in the office")}</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <Form fluid>
              <Stack
                style={{ marginTop: 10, marginBottom: 10 }}
                direction="row"
                alignItems="flex-start"
                spacing={10}
              >
                <Form.Group>
                  <Form.ControlLabel style={{ fontSize: 13, fontWeight: 'normal' }}>
                    {t('Users')}
                  </Form.ControlLabel>
                  <TagPicker
                    data={users.map(item => ({
                      value: item._id,
                      label: item.firstname + ' ' + item.lastname
                    }))}
                    style={{ width: 225 }}
                    placeholder={t('Select User(s)')}
                    loading={loadingusers}
                    placement="auto"
                    value={selectedUsers}
                    onChange={handleChangeMembers}
                  />
                </Form.Group>
                <Form.Group>
                  <Stack spacing={10} style={{ paddingTop: '20px' }}>
                    <Whisper
                      trigger="hover"
                      placement="top"
                      speaker={<Tooltip>{t('Workplace First Aid Responder')}</Tooltip>}
                    >
                      <Button
                        appearance="subtle"
                        onClick={() => handleFilterToggle('isSST')}
                        style={{
                          borderRadius: '50%',
                          padding: '8px',
                          backgroundColor: selectedFilters.includes('isSST')
                            ? '#c0c0c4'
                            : '#e5e5ea',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px'
                        }}
                      >
                        <ImAidKit size={15} color="#ff4d4f" />
                      </Button>
                    </Whisper>
                    <Whisper
                      trigger="hover"
                      placement="top"
                      speaker={<Tooltip>{t('Evacuation Guide')}</Tooltip>}
                    >
                      <Button
                        appearance="subtle"
                        onClick={() => handleFilterToggle('isGFSF')}
                        style={{
                          borderRadius: '50%',
                          padding: '8px',
                          backgroundColor: selectedFilters.includes('isGFSF')
                            ? '#c0c0c4'
                            : '#e5e5ea',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '32px',
                          height: '32px'
                        }}
                      >
                        <FaFireExtinguisher size={15} color="#ff9800" />
                      </Button>
                    </Whisper>
                  </Stack>
                </Form.Group>
              </Stack>
            </Form>
            {loadingUsersBuilding ? (
              <Stack justifyContent="center" style={{ marginTop: 50 }}>
                <Loader />
              </Stack>
            ) : (
              <>
                {usersBuilding?.length == 0 ? (
                  <Text>{t('No reservations found')}</Text>
                ) : (
                  <List>
                    <List.Item>
                      {usersBuilding?.length > 1
                        ? t('{{nb}} people in the office', { nb: usersBuilding?.length })
                        : t('{{nb}} person in the office', { nb: usersBuilding?.length })}
                    </List.Item>
                    {filteredUsersBuilding?.map(item => (
                      <List.Item key={item?.user?._id}>
                        <HStack spacing={15} alignItems="center">
                          {item.user.photo ? (
                            <Avatar
                              circle
                              src={process.env.REACT_APP_IMAGE_URL + item?.user?.photo}
                              alt={item?.user?.firstname}
                              size="sm"
                            />
                          ) : (
                            <Avatar circle size="sm" />
                          )}
                          <HStack.Item flex={1}>
                            <HStack justifyContent="space-between" alignItems="center">
                              <strong>
                                {item.user.firstname} {item.user.lastname}
                              </strong>
                              <HStack spacing={8}>
                                {item.user.isGuest && (
                                  <Tag color="blue" style={{ marginLeft: 8 }}>
                                    {t('Guest')}
                                  </Tag>
                                )}
                                {item.user.isSST && (
                                  <Whisper
                                    trigger="hover"
                                    placement="top"
                                    speaker={
                                      <Tooltip>{t('Workplace First Aid Responder')}</Tooltip>
                                    }
                                  >
                                    <span>
                                      <ImAidKit size={15} color="#ff4d4f" />
                                    </span>
                                  </Whisper>
                                )}
                                {item.user.isGFSF && (
                                  <Whisper
                                    trigger="hover"
                                    placement="top"
                                    speaker={<Tooltip>{t('Evacuation Guide')}</Tooltip>}
                                  >
                                    <span>
                                      <FaFireExtinguisher size={15} color="#ff9800" />
                                    </span>
                                  </Whisper>
                                )}
                              </HStack>
                            </HStack>
                            {item.reservations.map((reservation, index) => (
                              <Stack
                                key={index}
                                justifyContent="space-between"
                                style={{ marginTop: 5 }}
                              >
                                <Text size="sm">
                                  {t('Desk')} {reservation.desk} {reservation.floor} |{' '}
                                  {reservation.timeSlot}
                                </Text>
                                <Whisper
                                  trigger="hover"
                                  placement="top"
                                  speaker={<Tooltip>{t('Locate')}</Tooltip>}
                                >
                                  <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      if (reservation.timeSlot === 'FULL') {
                                        locateDesk(reservation.deskId, reservation.floorId, [
                                          'AM',
                                          'PM'
                                        ]);
                                      } else {
                                        locateDesk(reservation.deskId, reservation.floorId, [
                                          reservation.timeSlot
                                        ]);
                                      }
                                    }}
                                  >
                                    <RiMapPinUserFill size={15} />
                                  </div>
                                </Whisper>
                              </Stack>
                            ))}
                          </HStack.Item>
                        </HStack>
                      </List.Item>
                    ))}
                  </List>
                )}
              </>
            )}
          </Drawer.Body>
        </Drawer>
      )}
    </Panel>
  );
};

export default ContentPage;
